import {ChangeDetectionStrategy, Component, computed, input, InputSignal, OnInit} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
  MatTable, MatTableDataSource
} from '@angular/material/table';
import {MatTooltip} from '@angular/material/tooltip';

import {GroupRankingModel} from 'shared/models';
import {ConfigService} from '../../../config.service';

@Component({
  selector: 'rankings-ui',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, MatTable, MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTooltip],
  templateUrl: './rankings-ui.component.html',
  styleUrl: './rankings-ui.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RankingsUiComponent implements OnInit {
  groupsRankings: InputSignal<GroupRankingModel[]> = input.required<GroupRankingModel[]>();

  protected header1Columns: string[] = ['rank', 'player', 'matches', 'sets', 'games'];
  protected header2Columns: string[] = ['matchesPlayed', 'matchesFor', 'matchesAgainst', 'matchesDiff', 'setsFor', 'setsAgainst', 'setsDiff', 'gamesFor', 'gamesAgainst', 'gamesDiff'];
  protected displayedColumns: string[] = ['rank', 'player', 'matchesPlayed', 'matchesFor', 'matchesAgainst', 'matchesDiff', 'setsFor', 'setsAgainst', 'setsDiff', 'gamesFor', 'gamesAgainst', 'gamesDiff'];

  protected dataSource = computed((): MatTableDataSource<GroupRankingModel> => {
    return new MatTableDataSource<GroupRankingModel>(this.groupsRankings());
  });

  protected bucketUrl!: string;

  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    this.bucketUrl = this.configService.config.bucketUrl;
  }
}
